export default __webpack_public_path__ + "static/media/fb22768ad71b58de66ac84dd6cb51d01.bfb4c998.svg";